export const debounce = (func, wait, leadingExecution = false) => {
    function debounceWithLeadingExecution() {
        let currentlyRunning = false;
        return (...args) => {
            const enableRun = () => {
                currentlyRunning = false;
            };
            if (!currentlyRunning) {
                currentlyRunning = true;
                setTimeout(enableRun, wait);
                func(...args);
            }
        };
    }
    function debounceWithTrailingExecution() {
        let timer;
        return (...args) => {
            if (timer) {
                clearTimeout(timer);
            }
            timer = setTimeout(() => func(...args), wait);
        };
    }
    return leadingExecution ? debounceWithLeadingExecution() : debounceWithTrailingExecution();
};
